<div class="page-error-wrapper">
  <div>
    <div class="text-center mb-4"> <img src="assets/close.png"> </div>

    <h1 class="error-title">Un-Authorised</h1>
    <h5 class="error-subtitle">Oopps. The page is not for you.</h5>
    <p class="mb-5">You are not authorised to view this page.</p>
    <p class="mb-5"><a (click)="back()" [routerLink]="" class="btn btn-error">
        Back to Previous Page
      </a></p>
    <p class="mb-5"><a (click)="logOut()" class="btn btn-primary">
        Logout
      </a></p>
    <p class="error-footer p-2">&copy; Copyright {{today| date: 'yyyy'}}. All Rights Reserved.</p>
  </div>
</div>
